<style lang="less" scoped>
  .header {
    display: flex;
    justify-content: space-between;
    padding-bottom: 24px;
  }
  .back-btn {
    width: 44px;
    height: 44px;
    background: white;
    border-radius: 50%;
  }
</style>

<template lang="pug">
  .header
    back-button-component(@click.native='clickBackBtn')
</template>

<script>
import BackButtonComponent from '@/components/header_back_btn';

export default {
  methods: {
    clickBackBtn() {
      this.$emit('click-back');
    },
  },
  components: {
    BackButtonComponent,
  },
};
</script>



// WEBPACK FOOTER //
// src/components/header/back.vue